const NavbarVariant3 = ({ theme, font, editableData = {}, renderEditable }) => {
  const getText = (key, defaultValue) => {
    const value = editableData[key];
    return typeof value === "string" ? value : value?.text || defaultValue;
  };

  return (
    <nav className="w-full px-6 py-4 flex items-center justify-between border-b border-gray-200 bg-white shadow">
      <div
        className="text-2xl font-semibold"
        style={{ color: theme.primaryColor, fontFamily: font.mainText }}
      >
        {renderEditable
          ? renderEditable("brand", getText("brand", "MySite"))
          : getText("brand", "MySite")}
      </div>

      <div className="flex items-center space-x-6" style={{ fontFamily: font.mainText }}>
        <a
          href="#"
          className="text-sm font-medium hover:underline"
          style={{ color: theme.textColor }}
        >
          {renderEditable
            ? renderEditable("page_1", getText("page_1", "Home"))
            : getText("page_1", "Home")}
        </a>
        <a
          href="#"
          className="text-sm font-medium hover:underline"
          style={{ color: theme.textColor }}
        >
          {renderEditable
            ? renderEditable("page_2", getText("page_2", "Blog"))
            : getText("page_2", "Blog")}
        </a>
        <a
          href="#"
          className="text-sm font-medium hover:underline"
          style={{ color: theme.textColor }}
        >
          {renderEditable
            ? renderEditable("page_3", getText("page_3", "About"))
            : getText("page_3", "About")}
        </a>
        <button
          className="px-4 py-2 rounded-md text-white font-medium"
          style={{ backgroundColor: theme.primaryColor }}
        >
          {renderEditable
            ? renderEditable("CTA", getText("CTA", "Sign Up"))
            : getText("CTA", "Sign Up")}
        </button>
      </div>
    </nav>
  );
};

export default NavbarVariant3;
